// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Fetch = require("bs-fetch/src/Fetch.res.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var ReactHtmlParser = require("react-html-parser").default;
var ReactHtmlParser$1 = require("react-html-parser");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Mode$ReactHooksTemplate = require("./mode.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Modal$ReactHooksTemplate = require("./Modal.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var SmsMode$ReactHooksTemplate = require("./SmsMode.res.js");
var Campaign$ReactHooksTemplate = require("./campaign.res.js");
var EmailMode$ReactHooksTemplate = require("./EmailMode.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");
var AppLinkMode$ReactHooksTemplate = require("./AppLinkMode.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var EmailFromId$ReactHooksTemplate = require("./emailFromId.res.js");
var SmsLinkMode$ReactHooksTemplate = require("./SmsLinkMode.res.js");
var SmsSenderId$ReactHooksTemplate = require("./smsSenderId.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var SelectBoxNew$ReactHooksTemplate = require("../common/SelectBoxNew.res.js");
var SurveyDetail$ReactHooksTemplate = require("./surveyDetail.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");
var CampaignModes$ReactHooksTemplate = require("../general_settings/campaignModes.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var EmailTemplate$ReactHooksTemplate = require("./emailTemplate.res.js");
var WebsiteLinkMode$ReactHooksTemplate = require("./WebsiteLinkMode.res.js");
var ApiConfiguration$ReactHooksTemplate = require("../general_settings/apiConfiguration.res.js");
var EmailSenderPopUp$ReactHooksTemplate = require("../common/EmailSenderPopUp.res.js");
var TextAreaInputNew$ReactHooksTemplate = require("../common/TextAreaInputNew.res.js");
var WhatsappLinkMode$ReactHooksTemplate = require("./WhatsappLinkMode.res.js");
var AnonymousLinkMode$ReactHooksTemplate = require("./AnonymousLinkMode.res.js");
var ApplicationSetting$ReactHooksTemplate = require("../general_settings/applicationSetting.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");

function domIdFortemplateIdentifiers(x) {
  if (x === "EmailMessageBody") {
    return "emailMessageBody";
  } else {
    return "";
  }
}

function convertDomIdToTemplateIdentifier(id) {
  if (id === "emailMessageBody") {
    return "EmailMessageBody";
  } else {
    return "Unknown";
  }
}

function decodeNodeAttributes(json) {
  var id = Json_decode.optional((function (param) {
          return Json_decode.field("id", Json_decode.string, param);
        }), json);
  return convertDomIdToTemplateIdentifier(Belt_Option.getWithDefault(id, ""));
}

function decodeStatus(json) {
  return Json_decode.field("status", Json_decode.string, json).toLowerCase();
}

function decodeNameErrors(json) {
  return Json_decode.field("errors", (function (param) {
                return Json_decode.field("name", (function (param) {
                              return Json_decode.list(Json_decode.string, param);
                            }), param);
              }), json);
}

function decode(json) {
  var match = decodeStatus(json);
  switch (match) {
    case "failed" :
        return {
                TAG: "Failure",
                _0: decodeNameErrors(json)
              };
    case "success" :
        return "Success";
    default:
      return {
              TAG: "Failure",
              _0: /* [] */0
            };
  }
}

var CampaignApiResponse = {
  decodeStatus: decodeStatus,
  decodeNameErrors: decodeNameErrors,
  decode: decode
};

var emptyForm_name = {
  TAG: "Pristine",
  _0: Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.empty, undefined)
};

var emptyForm_survey = {
  TAG: "Pristine",
  _0: undefined
};

var emptyForm = {
  name: emptyForm_name,
  surveys: /* [] */0,
  smsSenderIds: /* [] */0,
  availableModes: Campaign$ReactHooksTemplate.availableModes,
  showAddMode: false,
  survey: emptyForm_survey,
  modes: /* [] */0,
  deletedModes: /* [] */0,
  emailFromIds: /* [] */0
};

function generateForm(campaign) {
  return {
          name: {
            TAG: "Valid",
            _0: Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.create, Campaign$ReactHooksTemplate.name(campaign))
          },
          surveys: /* [] */0,
          smsSenderIds: /* [] */0,
          availableModes: Campaign$ReactHooksTemplate.availableModes,
          showAddMode: false,
          survey: {
            TAG: "Pristine",
            _0: undefined
          },
          modes: Belt_List.map(Campaign$ReactHooksTemplate.modes(campaign), (function (x) {
                  return {
                          TAG: "Valid",
                          _0: Mode$ReactHooksTemplate.toForm(x)
                        };
                })),
          deletedModes: /* [] */0,
          emailFromIds: /* [] */0
        };
}

function reducer(state, action) {
  if (state.TAG === "FetchSurveysInProgress") {
    var form = state._0;
    if (typeof action !== "object") {
      return {
              TAG: "FetchSurveysInProgress",
              _0: form
            };
    }
    if (action.TAG !== "FetchSurveyCompleted") {
      return {
              TAG: "FetchSurveysInProgress",
              _0: form
            };
    }
    var surveys = action._0;
    var survey = Belt_List.head(surveys);
    return {
            TAG: "Available",
            _0: {
              name: form.name,
              surveys: surveys,
              smsSenderIds: form.smsSenderIds,
              availableModes: form.availableModes,
              showAddMode: form.showAddMode,
              survey: {
                TAG: "Valid",
                _0: survey
              },
              modes: form.modes,
              deletedModes: form.deletedModes,
              emailFromIds: form.emailFromIds
            }
          };
  } else {
    var form$1 = state._0;
    if (typeof action !== "object") {
      return {
              TAG: "Available",
              _0: {
                name: form$1.name,
                surveys: form$1.surveys,
                smsSenderIds: form$1.smsSenderIds,
                availableModes: form$1.availableModes,
                showAddMode: !form$1.showAddMode,
                survey: form$1.survey,
                modes: form$1.modes,
                deletedModes: form$1.deletedModes,
                emailFromIds: form$1.emailFromIds
              }
            };
    }
    switch (action.TAG) {
      case "FetchSurveyCompleted" :
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: action._0,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: form$1.modes,
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "ChangeNameInput" :
          return {
                  TAG: "Available",
                  _0: {
                    name: action._0,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: form$1.modes,
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "EmailModeChanged" :
          var emailMode = action._0;
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: Belt_List.map(form$1.modes, (function (x) {
                            var form = FormField$ReactHooksTemplate.getInputValue(x);
                            var match = form.formMode;
                            if (typeof match !== "object" || match.TAG !== "Email") {
                              return x;
                            } else {
                              return {
                                      TAG: "Valid",
                                      _0: {
                                        id: form.id,
                                        formMode: {
                                          TAG: "Email",
                                          _0: emailMode
                                        }
                                      }
                                    };
                            }
                          })),
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "SmsLinkModeChanged" :
          var smsLinkMode = action._0;
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: Belt_List.map(form$1.modes, (function (x) {
                            var form = FormField$ReactHooksTemplate.getInputValue(x);
                            var match = form.formMode;
                            if (typeof match !== "object" || match.TAG !== "SmsLink") {
                              return x;
                            } else {
                              return {
                                      TAG: "Valid",
                                      _0: {
                                        id: form.id,
                                        formMode: {
                                          TAG: "SmsLink",
                                          _0: smsLinkMode
                                        }
                                      }
                                    };
                            }
                          })),
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "WhatsappLinkModeChanged" :
          var whatsappLinkMode = action._0;
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: Belt_List.map(form$1.modes, (function (x) {
                            var form = FormField$ReactHooksTemplate.getInputValue(x);
                            var match = form.formMode;
                            if (typeof match !== "object" || match.TAG !== "WhatsappLink") {
                              return x;
                            } else {
                              return {
                                      TAG: "Valid",
                                      _0: {
                                        id: form.id,
                                        formMode: {
                                          TAG: "WhatsappLink",
                                          _0: whatsappLinkMode
                                        }
                                      }
                                    };
                            }
                          })),
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "AppLinkModeChanged" :
          var appLinkMode = action._0;
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: Belt_List.map(form$1.modes, (function (x) {
                            var form = FormField$ReactHooksTemplate.getInputValue(x);
                            var match = form.formMode;
                            if (typeof match !== "object" || match.TAG !== "AppLink") {
                              return x;
                            } else {
                              return {
                                      TAG: "Valid",
                                      _0: {
                                        id: form.id,
                                        formMode: {
                                          TAG: "AppLink",
                                          _0: appLinkMode
                                        }
                                      }
                                    };
                            }
                          })),
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "WebsiteLinkModeChanged" :
          var websiteLinkMode = action._0;
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: Belt_List.map(form$1.modes, (function (x) {
                            var form = FormField$ReactHooksTemplate.getInputValue(x);
                            var match = form.formMode;
                            if (typeof match !== "object" || match.TAG !== "WebsiteLink") {
                              return x;
                            } else {
                              return {
                                      TAG: "Valid",
                                      _0: {
                                        id: form.id,
                                        formMode: {
                                          TAG: "WebsiteLink",
                                          _0: websiteLinkMode
                                        }
                                      }
                                    };
                            }
                          })),
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "SmsModeChanged" :
          var smsMode = action._0;
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: Belt_List.map(form$1.modes, (function (x) {
                            var form = FormField$ReactHooksTemplate.getInputValue(x);
                            var match = form.formMode;
                            if (typeof match !== "object" || match.TAG !== "Sms") {
                              return x;
                            } else {
                              return {
                                      TAG: "Valid",
                                      _0: {
                                        id: form.id,
                                        formMode: {
                                          TAG: "Sms",
                                          _0: smsMode
                                        }
                                      }
                                    };
                            }
                          })),
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "AnonymousLinkModeChanged" :
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: Belt_List.map(form$1.modes, (function (x) {
                            FormField$ReactHooksTemplate.getInputValue(x);
                            return x;
                          })),
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "FailedApiResponse" :
          return {
                  TAG: "Available",
                  _0: {
                    name: {
                      TAG: "Invalid",
                      _0: FormField$ReactHooksTemplate.getInputValue(form$1.name),
                      _1: action._0
                    },
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: form$1.modes,
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "UpdateSurvey" :
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: {
                      TAG: "Valid",
                      _0: action._0
                    },
                    modes: form$1.modes,
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "AddMode" :
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: false,
                    survey: form$1.survey,
                    modes: {
                      hd: action._0,
                      tl: form$1.modes
                    },
                    deletedModes: form$1.deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      case "RemoveMode" :
          var mode = action._0;
          var modes = Belt_List.keep(form$1.modes, (function (x) {
                  return Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(FormField$ReactHooksTemplate.getInputValue(x))) !== Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(mode));
                }));
          var deletedModes = Belt_List.add(form$1.deletedModes, {
                TAG: "Valid",
                _0: mode
              });
          return {
                  TAG: "Available",
                  _0: {
                    name: form$1.name,
                    surveys: form$1.surveys,
                    smsSenderIds: form$1.smsSenderIds,
                    availableModes: form$1.availableModes,
                    showAddMode: form$1.showAddMode,
                    survey: form$1.survey,
                    modes: modes,
                    deletedModes: deletedModes,
                    emailFromIds: form$1.emailFromIds
                  }
                };
      
    }
  }
}

function validationErrors(field) {
  return JsxRuntime.jsx("div", {
              children: $$Array.of_list(Belt_List.mapWithIndex(FormField$ReactHooksTemplate.getValidationError(field), (function (key, error) {
                          return JsxRuntime.jsx("p", {
                                      children: error,
                                      className: "text-red-500 text-xs float-right"
                                    }, String(key));
                        }))),
              className: "my-2"
            });
}

function isValid(field) {
  switch (field.TAG) {
    case "Valid" :
        return true;
    case "Invalid" :
    case "Pristine" :
        return false;
    
  }
}

function isValidMode(form) {
  var mode = Belt_List.head(form.modes);
  if (mode === undefined) {
    return false;
  }
  switch (mode.TAG) {
    case "Valid" :
        return true;
    case "Invalid" :
    case "Pristine" :
        return false;
    
  }
}

function isValidSurvey(survey) {
  switch (survey.TAG) {
    case "Valid" :
        return true;
    case "Invalid" :
    case "Pristine" :
        return false;
    
  }
}

function isValidForm(form) {
  if (isValid(form.name) && isValidSurvey(form.survey)) {
    return isValidMode(form);
  } else {
    return false;
  }
}

function configurationTabClass(isSelected) {
  return "px-6 py-5 cursor-pointer transition-colors duration-200 border-l-2 " + (
          isSelected ? "bg-lavenderweb text-pigmentblue border-pigmentblue font-medium" : "border-transparent text-darkcharcoal hover:bg-ghostwhiteblue hover:text-pigmentblue"
        );
}

function CampaignForm(props) {
  var selectedCampaign = props.selectedCampaign;
  var toggleModal = props.toggleModal;
  var toggleCampaign = props.toggleCampaign;
  var match = React.useReducer(reducer, selectedCampaign !== undefined ? ({
            TAG: "FetchSurveysInProgress",
            _0: generateForm(Caml_option.valFromOption(selectedCampaign))
          }) : ({
            TAG: "FetchSurveysInProgress",
            _0: emptyForm
          }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setSenderIds = match$1[1];
  var senderIds = match$1[0];
  var match$2 = React.useState(function (param) {
        return /* [] */0;
      });
  var setEmailTemplates = match$2[1];
  var emailTempaltes = match$2[0];
  var match$3 = React.useState(function (param) {
        return "GeneralSettings";
      });
  var setSelected = match$3[1];
  var selected = match$3[0];
  var match$4 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var match$5 = React.useState(function (param) {
        return false;
      });
  var setShowPreview = match$5[1];
  var showPreview = match$5[0];
  var match$6 = React.useState(function (param) {
        return OrganizationProfile$ReactHooksTemplate.empty();
      });
  var setOrganization = match$6[1];
  var organization = match$6[0];
  var match$7 = React.useState(function (param) {
        return false;
      });
  var setNameError = match$7[1];
  var nameError = match$7[0];
  var match$8 = React.useState(function (param) {
        return /* [] */0;
      });
  var setEmailFromIds = match$8[1];
  var emailFromIds = match$8[0];
  var match$9 = React.useState(function (param) {
        return /* [] */0;
      });
  var setWhatsappApiConfigurations = match$9[1];
  var whatsappApiConfigurations = match$9[0];
  var match$10 = React.useState(function (param) {
        return EmailFromId$ReactHooksTemplate.empty();
      });
  var setNewEmailFromId = match$10[1];
  var newEmailFromId = match$10[0];
  var match$11 = React.useState(function (param) {
        return false;
      });
  var setShowEmailPopup = match$11[1];
  var showEmailPopup = match$11[0];
  var handleEmailInputChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    var trimmedValue = value.trim();
    Curry._1(setNewEmailFromId, (function (prev) {
            return EmailFromId$ReactHooksTemplate.setFromId(prev, trimmedValue);
          }));
  };
  var emailPopupModal = showEmailPopup ? JsxRuntime.jsx(EmailSenderPopUp$ReactHooksTemplate.make, {
          isOpen: showEmailPopup,
          onClose: (function (param) {
              Curry._1(setShowEmailPopup, (function (param) {
                      return false;
                    }));
              Curry._1(setNewEmailFromId, (function (param) {
                      return EmailFromId$ReactHooksTemplate.empty();
                    }));
            }),
          selectedFromId: newEmailFromId,
          onUpdateEmail: handleEmailInputChange,
          onSubmit: (function (param) {
              var value = EmailFromId$ReactHooksTemplate.fromId(newEmailFromId);
              var params = {};
              var encodedEmail = Json_encode.object_({
                    hd: [
                      "from_id",
                      value
                    ],
                    tl: {
                      hd: [
                        "default",
                        false
                      ],
                      tl: /* [] */0
                    }
                  });
              params["email_from_ids"] = encodedEmail;
              Curry._1(setShowEmailPopup, (function (param) {
                      return false;
                    }));
              Curry._1(setNewEmailFromId, (function (param) {
                      return EmailFromId$ReactHooksTemplate.empty();
                    }));
              Js_promise.then_((function (response) {
                      var status = Json_decode.field("status", (function (param) {
                              return Json_decode.withDefault("failed", Json_decode.string, param);
                            }), response);
                      if (status === "success") {
                        var newEmailId = Json_decode.field("email_from_ids", EmailFromId$ReactHooksTemplate.decode, response);
                        Curry._1(setEmailFromIds, (function (prev) {
                                return {
                                        hd: newEmailId,
                                        tl: prev
                                      };
                              }));
                        if (state.TAG !== "FetchSurveysInProgress") {
                          var emailModeOpt = Belt_List.getBy(state._0.modes, (function (x) {
                                  var modeForm = FormField$ReactHooksTemplate.getInputValue(x);
                                  var match = modeForm.formMode;
                                  if (typeof match !== "object" || match.TAG !== "Email") {
                                    return false;
                                  } else {
                                    return true;
                                  }
                                }));
                          if (emailModeOpt !== undefined) {
                            var modeForm = FormField$ReactHooksTemplate.getInputValue(emailModeOpt);
                            var emailMode = modeForm.formMode;
                            if (typeof emailMode === "object" && emailMode.TAG === "Email") {
                              var updatedEmailMode = EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setEmailFromId(EmailFromId$ReactHooksTemplate.id(newEmailId), EmailMode$ReactHooksTemplate.fromForm(emailMode._0)));
                              Curry._1(dispatch, {
                                    TAG: "EmailModeChanged",
                                    _0: updatedEmailMode
                                  });
                            }
                            
                          }
                          
                        }
                        return Promise.resolve();
                      }
                      console.log("Failed to create email");
                      return Promise.resolve();
                    }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/email_from_ids", params));
            }),
          isDisabled: EmailFromId$ReactHooksTemplate.fromId(newEmailFromId) === "",
          existingEmails: emailFromIds
        }) : null;
  var transform = function (emailBodyMessage, node, index) {
    var match = decodeNodeAttributes(node.attribs);
    if (match === "EmailMessageBody") {
      return JsxRuntime.jsx("div", {
                  children: ReactHtmlParser(emailBodyMessage, {
                        decodeEntities: true
                      }),
                  id: "emailMessageBody",
                  style: {
                    lineHeight: "2"
                  }
                });
    } else {
      return ReactHtmlParser$1.convertNodeToElement(node, index, (function (param, param$1) {
                    return transform(emailBodyMessage, param, param$1);
                  }));
    }
  };
  var usesStandaloneEmailBody = function (orgName) {
    var match = orgName.toLowerCase();
    switch (match) {
      case "edme insurance" :
      case "ncell" :
      case "yesbank" :
          return true;
      default:
        return false;
    }
  };
  var shouldSkipDefaultWrapper = function (organizationName, emailBody) {
    if (usesStandaloneEmailBody(organizationName)) {
      var trimmed = emailBody.trim();
      if (trimmed === "") {
        return false;
      } else if (trimmed.toLowerCase().startsWith("<!doctype") || trimmed.toLowerCase().startsWith("<html")) {
        return true;
      } else if (Js_string.includes("<table", trimmed)) {
        return Js_string.includes("</table>", trimmed);
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  var findEmailTemplate = function (templates, emailTemplateId) {
    var selected = emailTemplateId !== undefined ? Belt_List.getBy(templates, (function (t) {
              return EmailTemplate$ReactHooksTemplate.id(t) === emailTemplateId;
            })) : undefined;
    if (selected !== undefined) {
      return Caml_option.some(Caml_option.valFromOption(selected));
    } else {
      return Belt_List.head(templates);
    }
  };
  var renderEmailPreview = function (emailBody, emailTemplateId, templates, organizationName) {
    if (shouldSkipDefaultWrapper(organizationName, emailBody)) {
      return JsxRuntime.jsx("div", {
                  children: ReactHtmlParser(emailBody, {
                        decodeEntities: true
                      }),
                  className: "inline-block w-full"
                });
    }
    var emailTemplate = findEmailTemplate(templates, emailTemplateId);
    if (emailTemplate !== undefined) {
      return JsxRuntime.jsx("div", {
                  children: ReactHtmlParser(EmailTemplate$ReactHooksTemplate.html_template(Caml_option.valFromOption(emailTemplate)), {
                        transform: (function (param, param$1) {
                            return transform(emailBody, param, param$1);
                          })
                      }),
                  className: "inline-block w-full"
                });
    } else {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
  };
  var fetchEmailTemplates = function (param) {
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Curry._1(setEmailTemplates, (function (param) {
                                    return Json_decode.field("email_templates", (function (param) {
                                                  return Json_decode.list(EmailTemplate$ReactHooksTemplate.decode, param);
                                                }), json);
                                  })));
                }), Js_promise.then_((function (json) {
                      return Fetch.$$Response.json(json);
                    }), fetch("/api/v1/email_templates")));
  };
  var fetchSenderIds = function (param) {
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Curry._1(setSenderIds, (function (param) {
                                    return Json_decode.field("sms_sender_ids", (function (param) {
                                                  return Json_decode.list(SmsSenderId$ReactHooksTemplate.decode, param);
                                                }), json);
                                  })));
                }), Js_promise.then_((function (json) {
                      return Fetch.$$Response.json(json);
                    }), fetch("/api/v1/sms_sender_ids")));
  };
  var fetchOrganization = function (param) {
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Curry._1(setOrganization, (function (param) {
                                    return Json_decode.field("organization_profile", OrganizationProfile$ReactHooksTemplate.decode, json);
                                  })));
                }), Js_promise.then_((function (json) {
                      return Fetch.$$Response.json(json);
                    }), fetch("/api/v1/organization_profiles/1")));
  };
  var fetchEmailSenderIds = function (param) {
    return Js_promise.then_((function (json) {
                  return Promise.resolve(Curry._1(setEmailFromIds, (function (param) {
                                    return Json_decode.field("email_from_ids", (function (param) {
                                                  return Json_decode.list(EmailFromId$ReactHooksTemplate.decode, param);
                                                }), json);
                                  })));
                }), Js_promise.then_((function (json) {
                      return Fetch.$$Response.json(json);
                    }), fetch("/api/v1/email_from_ids")));
  };
  var fetchWhatsappApiConfigurations = function (param) {
    return Js_promise.$$catch((function (_error) {
                  return Promise.resolve();
                }), Js_promise.then_((function (apis) {
                      Curry._1(setWhatsappApiConfigurations, (function (param) {
                              return apis;
                            }));
                      return Promise.resolve();
                    }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/api_configurations?api_type=whatsapp", ApiConfiguration$ReactHooksTemplate.decodeList)));
  };
  React.useEffect((function (param) {
          fetchOrganization();
          fetchEmailTemplates();
          fetchSenderIds();
          fetchWhatsappApiConfigurations();
          Js_promise.then_((function (param) {
                  return Js_promise.then_((function (json) {
                                return Promise.resolve(Curry._1(dispatch, {
                                                TAG: "FetchSurveyCompleted",
                                                _0: Json_decode.field("surveys", (function (param) {
                                                        return Json_decode.list(SurveyDetail$ReactHooksTemplate.decode, param);
                                                      }), json)
                                              }));
                              }), Js_promise.then_((function (json) {
                                    return Fetch.$$Response.json(json);
                                  }), fetch("/api/v1/all_surveys")));
                }), fetchEmailSenderIds());
        }), []);
  var containsInvalidChar = function (specialCharRegex, words) {
    return List.exists((function (word) {
                  return List.exists((function (x) {
                                return Caml_obj.equal(word, x);
                              }), specialCharRegex);
                }), words);
  };
  var handleNameInput = function ($$event) {
    var name = $$event.target.value;
    var words = Belt_List.fromArray(Js_string.split("", name));
    var error = containsInvalidChar({
          hd: "<",
          tl: {
            hd: "!",
            tl: {
              hd: "=",
              tl: {
                hd: "+",
                tl: {
                  hd: "-",
                  tl: {
                    hd: "@",
                    tl: {
                      hd: ">",
                      tl: {
                        hd: "?",
                        tl: {
                          hd: "'",
                          tl: {
                            hd: "\"",
                            tl: {
                              hd: "$",
                              tl: {
                                hd: "#",
                                tl: {
                                  hd: "%",
                                  tl: {
                                    hd: "^",
                                    tl: {
                                      hd: "*",
                                      tl: {
                                        hd: "(",
                                        tl: {
                                          hd: ")",
                                          tl: {
                                            hd: "/",
                                            tl: {
                                              hd: ".",
                                              tl: {
                                                hd: "&",
                                                tl: {
                                                  hd: ",",
                                                  tl: {
                                                    hd: ";",
                                                    tl: {
                                                      hd: "`",
                                                      tl: {
                                                        hd: "~",
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }, words);
    if (Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.isEmpty, name)) {
      Curry._1(dispatch, {
            TAG: "ChangeNameInput",
            _0: {
              TAG: "Invalid",
              _0: name,
              _1: {
                hd: "can't be empty",
                tl: /* [] */0
              }
            }
          });
    } else {
      Curry._1(dispatch, {
            TAG: "ChangeNameInput",
            _0: {
              TAG: "Valid",
              _0: name
            }
          });
    }
    Curry._1(setNameError, (function (param) {
            return error;
          }));
  };
  var handleChangeModal = function (form, selectedCampaign$1) {
    if (selectedCampaign$1 !== undefined) {
      return function (param) {
        var selectedCampaign$2 = Belt_Option.getExn(selectedCampaign);
        var modes = Belt_List.toArray(Belt_List.concat(Belt_List.map(Belt_List.map(Belt_List.map(form.modes, FormField$ReactHooksTemplate.getInputValue), Mode$ReactHooksTemplate.fromForm), (function (x) {
                        return Mode$ReactHooksTemplate.encoder(undefined, x);
                      })), Belt_List.map(Belt_List.map(Belt_List.map(form.deletedModes, FormField$ReactHooksTemplate.getInputValue), Mode$ReactHooksTemplate.fromForm), (function (x) {
                        return Mode$ReactHooksTemplate.encoder(true, x);
                      }))));
        var buildTargetDict = function (form) {
          var campaignFields_0 = [
            "name",
            Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, FormField$ReactHooksTemplate.getInputValue(form.name))
          ];
          var campaignFields_1 = {
            hd: [
              "survey_id",
              Campaign$ReactHooksTemplate.surveyId(selectedCampaign$2)
            ],
            tl: {
              hd: [
                "campaign_modes_attributes",
                modes
              ],
              tl: /* [] */0
            }
          };
          var campaignFields = {
            hd: campaignFields_0,
            tl: campaignFields_1
          };
          var params = {};
          params["campaign"] = Json_encode.object_(campaignFields);
          return params;
        };
        var campaignId = Campaign$ReactHooksTemplate.id(selectedCampaign$2);
        Js_promise.then_((function (response) {
                Curry._1(toggleCampaign, "save");
                return Promise.resolve(response);
              }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/campaigns/" + String(campaignId) + "/update", buildTargetDict(form)));
      };
    } else {
      return function (param) {
        var modes = Belt_List.map(Belt_List.map(form.modes, FormField$ReactHooksTemplate.getInputValue), Mode$ReactHooksTemplate.fromForm);
        var partial_arg = false;
        var campaignFields_0 = [
          "name",
          Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, FormField$ReactHooksTemplate.getInputValue(form.name))
        ];
        var campaignFields_1 = {
          hd: [
            "survey_id",
            SurveyDetail$ReactHooksTemplate.id(param)
          ],
          tl: {
            hd: [
              "campaign_modes_attributes",
              Json_encode.list((function (param) {
                      return Mode$ReactHooksTemplate.encoder(partial_arg, param);
                    }), modes)
            ],
            tl: /* [] */0
          }
        };
        var campaignFields = {
          hd: campaignFields_0,
          tl: campaignFields_1
        };
        var campaignEncoder = Json_encode.object_(campaignFields);
        Js_promise.then_((function (response) {
                Curry._1(toggleCampaign, "save");
                return Promise.resolve(response);
              }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/campaigns", Json_encode.object_({
                      hd: [
                        "campaign",
                        campaignEncoder
                      ],
                      tl: /* [] */0
                    })));
      };
    }
  };
  var addOrRemove = function (form, modeString, $$event) {
    var selected = Belt_List.getBy(form.modes, (function (x) {
            return modeString === Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(FormField$ReactHooksTemplate.getInputValue(x)));
          }));
    if (selected === undefined) {
      var mode;
      switch (modeString) {
        case "AnonymousLink" :
            mode = {
              TAG: "Valid",
              _0: {
                id: undefined,
                formMode: {
                  TAG: "AnonymousLink",
                  _0: AnonymousLinkMode$ReactHooksTemplate.toForm(AnonymousLinkMode$ReactHooksTemplate.empty())
                }
              }
            };
            break;
        case "AppLink" :
            mode = {
              TAG: "Pristine",
              _0: {
                id: undefined,
                formMode: {
                  TAG: "AppLink",
                  _0: AppLinkMode$ReactHooksTemplate.toForm(AppLinkMode$ReactHooksTemplate.empty())
                }
              }
            };
            break;
        case "Email" :
            var initialFromId = Belt_Option.flatMap(Belt_List.head(emailFromIds), EmailFromId$ReactHooksTemplate.id);
            var emptyEmailMode = EmailMode$ReactHooksTemplate.setEmailFromId(initialFromId, EmailMode$ReactHooksTemplate.empty());
            var emailTemplate = Belt_List.head(emailTempaltes);
            mode = {
              TAG: "Pristine",
              _0: {
                id: undefined,
                formMode: emailTemplate !== undefined ? ({
                      TAG: "Email",
                      _0: EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setEmailTemplateId(EmailTemplate$ReactHooksTemplate.id(Caml_option.valFromOption(emailTemplate)), emptyEmailMode))
                    }) : ({
                      TAG: "Email",
                      _0: EmailMode$ReactHooksTemplate.toForm(emptyEmailMode)
                    })
              }
            };
            break;
        case "Sms" :
            mode = {
              TAG: "Pristine",
              _0: {
                id: undefined,
                formMode: {
                  TAG: "Sms",
                  _0: SmsMode$ReactHooksTemplate.toForm(SmsMode$ReactHooksTemplate.empty())
                }
              }
            };
            break;
        case "SmsLink" :
            mode = {
              TAG: "Pristine",
              _0: {
                id: undefined,
                formMode: {
                  TAG: "SmsLink",
                  _0: SmsLinkMode$ReactHooksTemplate.toForm(SmsLinkMode$ReactHooksTemplate.empty())
                }
              }
            };
            break;
        case "Telephonic" :
            mode = {
              TAG: "Valid",
              _0: {
                id: undefined,
                formMode: "Telephonic"
              }
            };
            break;
        case "WebsiteLink" :
            mode = {
              TAG: "Pristine",
              _0: {
                id: undefined,
                formMode: {
                  TAG: "WebsiteLink",
                  _0: WebsiteLinkMode$ReactHooksTemplate.toForm(WebsiteLinkMode$ReactHooksTemplate.empty())
                }
              }
            };
            break;
        case "WhatsappLink" :
            var activeApis = Belt_List.keep(whatsappApiConfigurations, (function (api) {
                    return api.isActive;
                  }));
            var initialId = activeApis && !activeApis.tl ? activeApis.hd.id : undefined;
            mode = {
              TAG: "Pristine",
              _0: {
                id: undefined,
                formMode: {
                  TAG: "WhatsappLink",
                  _0: WhatsappLinkMode$ReactHooksTemplate.toForm(WhatsappLinkMode$ReactHooksTemplate.setApiConfigurationId(initialId, WhatsappLinkMode$ReactHooksTemplate.empty()))
                }
              }
            };
            break;
        default:
          mode = {
            TAG: "Pristine",
            _0: {
              id: undefined,
              formMode: {
                TAG: "Email",
                _0: EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.empty())
              }
            }
          };
      }
      return Curry._1(dispatch, {
                  TAG: "AddMode",
                  _0: mode
                });
    }
    var mode$1 = FormField$ReactHooksTemplate.getInputValue(selected);
    Curry._1(dispatch, {
          TAG: "RemoveMode",
          _0: mode$1
        });
  };
  var findChecked = function (form, modeString) {
    return Belt_List.getBy(form.modes, (function (x) {
                  return modeString === Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(FormField$ReactHooksTemplate.getInputValue(x)));
                })) !== undefined;
  };
  var modeView = function (form, mode) {
    var selected = Belt_List.getBy(form.modes, (function (x) {
            return Mode$ReactHooksTemplate.modeType(mode) === Mode$ReactHooksTemplate.modeType(Mode$ReactHooksTemplate.fromForm(FormField$ReactHooksTemplate.getInputValue(x)));
          }));
    if (selected === undefined) {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
    var mode$1 = FormField$ReactHooksTemplate.getInputValue(selected);
    var emailMode = mode$1.formMode;
    if (typeof emailMode !== "object") {
      return JsxRuntime.jsx(JsxRuntime.Fragment, {});
    }
    switch (emailMode.TAG) {
      case "Email" :
          var emailMode$1 = emailMode._0;
          var emailFromIdOptions = Belt_List.map(emailFromIds, EmailFromId$ReactHooksTemplate.fromId);
          var id = EmailMode$ReactHooksTemplate.fromId(EmailMode$ReactHooksTemplate.fromForm(emailMode$1));
          var selectedEmailFromId = id !== undefined ? Belt_Option.getWithDefault(Belt_Option.map(Belt_List.getBy(emailFromIds, (function (x) {
                            return Caml_obj.equal(EmailFromId$ReactHooksTemplate.id(x), id);
                          })), EmailFromId$ReactHooksTemplate.fromId), "") : "";
          var partial_arg = EmailMode$ReactHooksTemplate.fromForm(emailMode$1);
          var partial_arg$1 = EmailMode$ReactHooksTemplate.fromForm(emailMode$1);
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(SelectBoxNew$ReactHooksTemplate.make, {
                                                  label: "Select From address",
                                                  value: selectedEmailFromId,
                                                  handleChange: (function ($$event) {
                                                      var selectedFromId = $$event.target.value;
                                                      var id = Belt_Option.flatMap(Belt_List.getBy(emailFromIds, (function (x) {
                                                                  return EmailFromId$ReactHooksTemplate.fromId(x) === selectedFromId;
                                                                })), EmailFromId$ReactHooksTemplate.id);
                                                      if (id !== undefined) {
                                                        return Curry._1(dispatch, {
                                                                    TAG: "EmailModeChanged",
                                                                    _0: EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setEmailFromId(id, EmailMode$ReactHooksTemplate.fromForm(emailMode$1)))
                                                                  });
                                                      }
                                                      
                                                    }),
                                                  labelCSS: "text-sm font-medium text-gray-700",
                                                  className: "bg-white block border border-gray-400 flex-1 ml-64 normal-case px-3 py-2 rounded text-sm",
                                                  options: emailFromIdOptions
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("a", {
                                                        children: "+ Add New email address",
                                                        className: "text-xs text-blue-600 cursor-pointer inline-block",
                                                        onClick: (function (param) {
                                                            Curry._1(setShowEmailPopup, (function (prev) {
                                                                    return !prev;
                                                                  }));
                                                            Curry._1(setNewEmailFromId, (function (param) {
                                                                    return EmailFromId$ReactHooksTemplate.empty();
                                                                  }));
                                                          })
                                                      }),
                                                  className: "ml-8 ml-auto mt-1 px-2.5 w-1/2"
                                                })
                                          ],
                                          className: "max-w-3xl"
                                        }),
                                    className: "p-6"
                                  }),
                              className: "mb-4 w-4/5"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                                                      label: "Subject",
                                                      value: FormField$ReactHooksTemplate.getInputValue(emailMode$1.subject),
                                                      handleChange: (function (param) {
                                                          var value = Utils$ReactHooksTemplate.formTargetValue(param);
                                                          return Curry._1(dispatch, {
                                                                      TAG: "EmailModeChanged",
                                                                      _0: EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setSubject(value, partial_arg))
                                                                    });
                                                        }),
                                                      maxLength: 100
                                                    }),
                                                validationErrors(emailMode$1.subject)
                                              ],
                                              className: "mb-8"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(TextAreaInputNew$ReactHooksTemplate.make, {
                                                      label: "Body",
                                                      value: FormField$ReactHooksTemplate.getInputValue(emailMode$1.body),
                                                      handleChange: (function (param) {
                                                          var value = Utils$ReactHooksTemplate.formTargetValue(param);
                                                          return Curry._1(dispatch, {
                                                                      TAG: "EmailModeChanged",
                                                                      _0: EmailMode$ReactHooksTemplate.toForm(EmailMode$ReactHooksTemplate.setBody(value, partial_arg$1))
                                                                    });
                                                        })
                                                    }),
                                                validationErrors(emailMode$1.body)
                                              ]
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("img", {
                                                            src: Image$ReactHooksTemplate.preview
                                                          }),
                                                      JsxRuntime.jsx("p", {
                                                            children: "Preview"
                                                          })
                                                    ],
                                                    className: "flex items-center justify-between gap-1 text-white"
                                                  }),
                                              className: "bg-pigmentblue border border-gray-400\n                          flex rounded p-2 text-sm",
                                              type: "button",
                                              onClick: (function (param) {
                                                  Curry._1(setShowPreview, (function (param) {
                                                          return !showPreview;
                                                        }));
                                                })
                                            })
                                      ],
                                      className: "p-6 bg-ghostwhite border border-gray-300 rounded-lg w-4/5"
                                    }),
                                JsxRuntime.jsx(Modal$ReactHooksTemplate.make, {
                                      show: showPreview,
                                      children: JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("div", {
                                                  children: renderEmailPreview(FormField$ReactHooksTemplate.getInputValue(emailMode$1.body), FormField$ReactHooksTemplate.getInputValue(emailMode$1.emailTemplateId), emailTempaltes, OrganizationProfile$ReactHooksTemplate.name(organization)),
                                                  className: "my-6 w-full px-5 py-5 email-template overflow-auto"
                                                }),
                                            className: "w-screen bg-desertstorm pt-6"
                                          }),
                                      handleClose: (function (param) {
                                          Curry._1(setShowPreview, (function (param) {
                                                  return !showPreview;
                                                }));
                                        })
                                    })
                              ],
                              className: "flex mb-8"
                            })
                      ]
                    });
      case "Sms" :
          var smsMode = emailMode._0;
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Sender ID",
                              className: "text-sm font-medium mb-2"
                            }),
                        JsxRuntime.jsxs("select", {
                              children: [
                                JsxRuntime.jsx("option", {
                                      children: "Select SenderId",
                                      value: "0"
                                    }, "0"),
                                $$Array.of_list(Belt_List.mapWithIndex(senderIds, (function (idx, x) {
                                            return JsxRuntime.jsx("option", {
                                                        children: x.senderId,
                                                        selected: x.id === SmsMode$ReactHooksTemplate.senderId(SmsMode$ReactHooksTemplate.fromForm(smsMode)),
                                                        value: String(x.id)
                                                      }, String(idx));
                                          })))
                              ],
                              className: "h-10 w-3/5 block border px-3 py-2 border-gray-400\n                           w-52 bg-white rounded capitalize text-sm",
                              placeholder: "Select Sender",
                              value: String(SmsMode$ReactHooksTemplate.senderId(SmsMode$ReactHooksTemplate.fromForm(smsMode))),
                              onChange: (function ($$event) {
                                  var smsMode = Belt_List.getBy(form.modes, (function (x) {
                                          var match = FormField$ReactHooksTemplate.getInputValue(x).formMode;
                                          if (typeof match !== "object" || match.TAG !== "Sms") {
                                            return false;
                                          } else {
                                            return true;
                                          }
                                        }));
                                  if (smsMode === undefined) {
                                    return ;
                                  }
                                  var modeForm = FormField$ReactHooksTemplate.getInputValue(smsMode);
                                  var smsForm = modeForm.formMode;
                                  if (typeof smsForm !== "object" || smsForm.TAG !== "Sms") {
                                    return ;
                                  } else {
                                    var smsMode$1 = smsForm._0;
                                    var value = Caml_format.int_of_string(Utils$ReactHooksTemplate.formTargetValue($$event));
                                    var updatedSmsMode = SmsMode$ReactHooksTemplate.toForm(SmsMode$ReactHooksTemplate.setSenderId(value, SmsMode$ReactHooksTemplate.fromForm(smsMode$1)));
                                    return Curry._1(dispatch, {
                                                TAG: "SmsModeChanged",
                                                _0: updatedSmsMode
                                              });
                                  }
                                })
                            })
                      ],
                      className: "p-6 bg-ghostwhite border border-gray-300 rounded-lg mb-8\n                         flex justify-between items-center"
                    });
      case "SmsLink" :
          var smsLinkMode = emailMode._0;
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(TextAreaInputNew$ReactHooksTemplate.make, {
                              label: "Message",
                              value: FormField$ReactHooksTemplate.getInputValue(smsLinkMode.message),
                              handleChange: (function (param) {
                                  var value = Utils$ReactHooksTemplate.formTargetValue(param);
                                  var updatedForm = SmsLinkMode$ReactHooksTemplate.toForm(SmsLinkMode$ReactHooksTemplate.setMessage(value, SmsLinkMode$ReactHooksTemplate.fromForm(smsLinkMode)));
                                  return Curry._1(dispatch, {
                                              TAG: "SmsLinkModeChanged",
                                              _0: updatedForm
                                            });
                                })
                            }),
                        validationErrors(smsLinkMode.message)
                      ],
                      className: "p-6 bg-ghostwhite border border-gray-300 rounded-lg mb-8"
                    });
      case "WhatsappLink" :
          var whatsappLinkMode = emailMode._0;
          var boundId = WhatsappLinkMode$ReactHooksTemplate.apiConfigurationId(WhatsappLinkMode$ReactHooksTemplate.fromForm(whatsappLinkMode));
          var selectableApis = Belt_List.keep(whatsappApiConfigurations, (function (api) {
                  if (api.isActive) {
                    return true;
                  } else {
                    return Caml_obj.equal(api.id, boundId);
                  }
                }));
          var selectedValue = boundId !== undefined ? String(boundId) : "0";
          return JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: "WhatsApp API",
                                            className: "text-sm font-medium mb-2"
                                          }),
                                      JsxRuntime.jsxs("select", {
                                            children: [
                                              JsxRuntime.jsx("option", {
                                                    children: "Select WhatsApp API",
                                                    value: "0"
                                                  }, "0"),
                                              $$Array.of_list(Belt_List.map(selectableApis, (function (api) {
                                                          var optionId = Belt_Option.getWithDefault(api.id, 0);
                                                          var label = api.isActive ? api.name : api.name + " (Inactive)";
                                                          return JsxRuntime.jsx("option", {
                                                                      children: label,
                                                                      value: String(optionId)
                                                                    }, String(optionId));
                                                        })))
                                            ],
                                            className: "h-10 w-3/5 block border px-3 py-2 border-gray-400\n                                 w-52 bg-white rounded capitalize text-sm",
                                            value: selectedValue,
                                            onChange: (function ($$event) {
                                                var raw = Caml_format.int_of_string(Utils$ReactHooksTemplate.formTargetValue($$event));
                                                var id = raw === 0 ? undefined : raw;
                                                var updatedForm = WhatsappLinkMode$ReactHooksTemplate.toForm(WhatsappLinkMode$ReactHooksTemplate.setApiConfigurationId(id, WhatsappLinkMode$ReactHooksTemplate.fromForm(whatsappLinkMode)));
                                                Curry._1(dispatch, {
                                                      TAG: "WhatsappLinkModeChanged",
                                                      _0: updatedForm
                                                    });
                                              })
                                          })
                                    ],
                                    className: "flex justify-between items-center mb-4"
                                  }),
                              validationErrors(whatsappLinkMode.apiConfigurationId),
                              Belt_List.length(selectableApis) === 0 ? JsxRuntime.jsx("p", {
                                      children: "No WhatsApp API configurations available. Add one under General Settings.",
                                      className: "text-sm text-firebrick mb-4"
                                    }) : null
                            ]
                          }),
                      className: "p-6 bg-ghostwhite border border-gray-300 rounded-lg mb-8"
                    });
      case "AppLink" :
          var appLinkMode = emailMode._0;
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(TextAreaInputNew$ReactHooksTemplate.make, {
                              label: "Message",
                              value: FormField$ReactHooksTemplate.getInputValue(appLinkMode.message),
                              handleChange: (function (param) {
                                  var value = Utils$ReactHooksTemplate.formTargetValue(param);
                                  var updatedForm = AppLinkMode$ReactHooksTemplate.toForm(AppLinkMode$ReactHooksTemplate.setMessage(value, AppLinkMode$ReactHooksTemplate.fromForm(appLinkMode)));
                                  return Curry._1(dispatch, {
                                              TAG: "AppLinkModeChanged",
                                              _0: updatedForm
                                            });
                                })
                            }),
                        validationErrors(appLinkMode.message)
                      ],
                      className: "p-6 bg-ghostwhite border border-gray-300 rounded-lg mb-8"
                    });
      case "WebsiteLink" :
          var websiteLinkMode = emailMode._0;
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(TextAreaInputNew$ReactHooksTemplate.make, {
                              label: "Message",
                              value: FormField$ReactHooksTemplate.getInputValue(websiteLinkMode.message),
                              handleChange: (function (param) {
                                  var value = Utils$ReactHooksTemplate.formTargetValue(param);
                                  var updatedForm = WebsiteLinkMode$ReactHooksTemplate.toForm(WebsiteLinkMode$ReactHooksTemplate.setMessage(value, WebsiteLinkMode$ReactHooksTemplate.fromForm(websiteLinkMode)));
                                  return Curry._1(dispatch, {
                                              TAG: "WebsiteLinkModeChanged",
                                              _0: updatedForm
                                            });
                                })
                            }),
                        validationErrors(websiteLinkMode.message)
                      ],
                      className: "p-6 bg-ghostwhite border border-gray-300 rounded-lg mb-8"
                    });
      case "AnonymousLink" :
          return JsxRuntime.jsx(JsxRuntime.Fragment, {});
      
    }
  };
  if (state.TAG === "FetchSurveysInProgress") {
    return JsxRuntime.jsx("p", {
                children: "Loading..."
              });
  }
  var form = state._0;
  var survey = form.survey;
  var selectedSurvey;
  switch (survey.TAG) {
    case "Valid" :
        var survey$1 = survey._0;
        selectedSurvey = survey$1 !== undefined ? String(SurveyDetail$ReactHooksTemplate.id(survey$1)) : "";
        break;
    case "Invalid" :
    case "Pristine" :
        selectedSurvey = "";
        break;
    
  }
  var campaignModes = selectedCampaign !== undefined ? List.flatten(Belt_List.map(List.flatten(Belt_List.map(Campaign$ReactHooksTemplate.applicationSettings(Caml_option.valFromOption(selectedCampaign)), (function (x) {
                        var y = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
                        if (y.TAG === "CampaignModes") {
                          return CampaignModes$ReactHooksTemplate.value(y._0);
                        } else {
                          return /* [] */0;
                        }
                      }))), (function (y) {
                return Belt_List.keep(form.availableModes, (function (x) {
                              return Mode$ReactHooksTemplate.modeType(x) === y;
                            }));
              }))) : List.flatten(Belt_List.map(List.flatten(Belt_List.map(OrganizationProfile$ReactHooksTemplate.applicationSettings(organization), (function (x) {
                        var y = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
                        if (y.TAG === "CampaignModes") {
                          return CampaignModes$ReactHooksTemplate.value(y._0);
                        } else {
                          return /* [] */0;
                        }
                      }))), (function (y) {
                return Belt_List.keep(form.availableModes, (function (x) {
                              return Mode$ReactHooksTemplate.modeType(x) === y;
                            }));
              })));
  var tmp;
  if (Curry._1(match$4[0], "CreateCampaign")) {
    var tmp$1;
    tmp$1 = selected === "GeneralSettings" ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                            label: "Campaign Name",
                            value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Name.show, FormField$ReactHooksTemplate.getInputValue(form.name)),
                            handleChange: handleNameInput,
                            maxLength: 100
                          }),
                      nameError ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("p", {
                                    children: "special characters are not allowed",
                                    className: "text-red-500 text-xs float-right"
                                  }),
                              className: "my-2"
                            }) : validationErrors(form.name)
                    ],
                    className: "mb-6"
                  }),
              JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "Select Survey",
                                  className: "text-sm font-medium"
                                }),
                            selectedCampaign !== undefined ? JsxRuntime.jsx("input", {
                                    className: "outline-none border border-gray-400 h-10 w-3/5 rounded px-3 py-2 text-sm cursor-not-allowed bg-gray-50",
                                    disabled: true,
                                    type: "text",
                                    value: Campaign$ReactHooksTemplate.surveyName(Caml_option.valFromOption(selectedCampaign))
                                  }) : JsxRuntime.jsx("select", {
                                    children: $$Array.of_list(Belt_List.mapWithIndex(form.surveys, (function (idx, x) {
                                                return JsxRuntime.jsx("option", {
                                                            children: x.name,
                                                            value: String(x.id)
                                                          }, String(idx));
                                              }))),
                                    className: "h-10 w-3/5 block border px-3 py-2 border-gray-400\n                                  w-52 bg-white rounded capitalize text-sm cursor-pointer ",
                                    value: selectedSurvey,
                                    onChange: (function (param) {
                                        var value = Utils$ReactHooksTemplate.formTargetValue(param);
                                        var selectedSurvey = List.find((function (x) {
                                                return String(SurveyDetail$ReactHooksTemplate.id(x)) === value;
                                              }), form.surveys);
                                        return Curry._1(dispatch, {
                                                    TAG: "UpdateSurvey",
                                                    _0: selectedSurvey
                                                  });
                                      })
                                  })
                          ],
                          className: "flex justify-between items-center"
                        }),
                    className: "mb-6"
                  })
            ],
            className: "h-full"
          }) : JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
                  children: selectedCampaign !== undefined ? JsxRuntime.jsx(JsxRuntime.Fragment, {
                          children: Caml_option.some(JsxRuntime.jsx("div", {
                                    children: $$Array.of_list(Belt_List.map(campaignModes, (function (mode) {
                                                var partial_arg = Mode$ReactHooksTemplate.modeType(mode);
                                                return JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                                    checked: findChecked(form, Mode$ReactHooksTemplate.modeType(mode)),
                                                                    label: Mode$ReactHooksTemplate.modeType(mode),
                                                                    handleChange: (function (param) {
                                                                        return addOrRemove(form, partial_arg, param);
                                                                      }),
                                                                    className: "mb-8",
                                                                    checkboxClassName: "blue_checkbox"
                                                                  }, Mode$ReactHooksTemplate.modeType(mode)),
                                                              modeView(form, mode)
                                                            ],
                                                            className: "h-full"
                                                          });
                                              }))),
                                    className: "flex flex-col overflow-y-scroll h-full"
                                  }))
                        }) : JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: $$Array.of_list(Belt_List.map(campaignModes, (function (x) {
                                            var partial_arg = Mode$ReactHooksTemplate.modeType(x);
                                            return JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                                checked: findChecked(form, Mode$ReactHooksTemplate.modeType(x)),
                                                                label: Mode$ReactHooksTemplate.modeType(x),
                                                                handleChange: (function (param) {
                                                                    return addOrRemove(form, partial_arg, param);
                                                                  }),
                                                                className: "mb-8",
                                                                checkboxClassName: "blue_checkbox"
                                                              }, Mode$ReactHooksTemplate.modeType(x)),
                                                          modeView(form, x)
                                                        ],
                                                        className: "h-full"
                                                      });
                                          }))),
                                className: "flex flex-col overflow-y-scroll h-full"
                              }),
                          className: "h-full"
                        }),
                  className: "h-full"
                }),
            className: "h-full"
          });
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: selectedCampaign !== undefined ? JsxRuntime.jsx("div", {
                                  children: "Edit Campaign"
                                }) : JsxRuntime.jsx("div", {
                                  children: "Create New Campaign"
                                })
                        }),
                    JsxRuntime.jsx("img", {
                          className: "h-14-px float-right cursor-pointer",
                          src: Image$ReactHooksTemplate.closeIcon,
                          onClick: toggleModal
                        })
                  ],
                  className: "p-8 text-lg font-bold flex justify-between border-b border-gray-300 h-20"
                }),
            JsxRuntime.jsxs("form", {
                  children: [
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: "General Settings",
                                                className: configurationTabClass(selected === "GeneralSettings"),
                                                onClick: (function (param) {
                                                    Curry._1(setSelected, (function (param) {
                                                            return "GeneralSettings";
                                                          }));
                                                  })
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: "Campaign Modes",
                                                className: configurationTabClass(selected === "CampaignModes"),
                                                onClick: (function (param) {
                                                    Curry._1(setSelected, (function (param) {
                                                            return "CampaignModes";
                                                          }));
                                                  })
                                              })
                                        ],
                                        className: "w-2/10 flex flex-col border-r border-gray-300\n                                  text-darkcharcoal text-base"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: tmp$1,
                                        className: "w-8/10 flex flex-col p-8 h-full"
                                      })
                                ],
                                className: "flex h-full"
                              }),
                          style: {
                            height: "calc(100vh - 11rem)"
                          }
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("button", {
                                  children: "Discard",
                                  className: "bg-ghostwhite border border-gray-400`\n                   flex rounded py-3 px-6 text-xs",
                                  id: "close_modal",
                                  onClick: toggleModal
                                }),
                            JsxRuntime.jsx("input", {
                                  className: "bg-palatinateblue border border-gray-400\n                   flex rounded py-3 px-6 text-xs text-white " + (
                                    !isValidForm(form) || nameError ? "disabled-input" : "cursor-pointer"
                                  ),
                                  disabled: !isValidForm(form) || nameError,
                                  type: "submit",
                                  value: "Save"
                                })
                          ],
                          className: "p-5 flex border-t border-gray-200 justify-end gap-3 font-medium\n                  text-base w-full h-20" + (
                            showPreview ? " hidden" : ""
                          )
                        })
                  ],
                  className: "h-full flex flex-col",
                  onSubmit: (function (param) {
                      param.preventDefault();
                      return Belt_Option.mapWithDefault(FormField$ReactHooksTemplate.getInputValue(form.survey), undefined, handleChangeModal(form, selectedCampaign));
                    })
                })
          ],
          className: "h-full flex flex-col"
        });
  } else {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                text: "401: Unauthorized!!",
                loading: false
              }),
          className: "h-screen w-full animated fadeIn"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                tmp,
                emailPopupModal
              ],
              className: "h-full"
            });
}

var make = CampaignForm;

exports.domIdFortemplateIdentifiers = domIdFortemplateIdentifiers;
exports.convertDomIdToTemplateIdentifier = convertDomIdToTemplateIdentifier;
exports.decodeNodeAttributes = decodeNodeAttributes;
exports.CampaignApiResponse = CampaignApiResponse;
exports.emptyForm = emptyForm;
exports.generateForm = generateForm;
exports.reducer = reducer;
exports.validationErrors = validationErrors;
exports.isValid = isValid;
exports.isValidMode = isValidMode;
exports.isValidSurvey = isValidSurvey;
exports.isValidForm = isValidForm;
exports.configurationTabClass = configurationTabClass;
exports.make = make;
/* emptyForm Not a pure module */
